import { connect } from 'react-redux';
// import {  } from '../reducers/auth.reducers';
import {
  loadSocialWallPostsAction,
  createSocialWallPostAction,
  createResponseAction,
  updateSocialWallPostAction,
} from '../../reducers/socialwall.reducers';
import SocialWallPost from './socialwall-post';

const mapDispatchToProps = dispatch => ({
  loadSocialPosts: dto => dispatch(loadSocialWallPostsAction(dto)),
  createPost: dto => dispatch(createSocialWallPostAction(dto)),
  createResponse: dto => dispatch(createResponseAction(dto)),
  updatePost: (id, dto) => dispatch(updateSocialWallPostAction({ id, dto })),
});

const mapStateToProps = state => ({
  user: state.authentication.user,
  roles: state.authentication.roles,
});

export default connect(mapStateToProps, mapDispatchToProps)(SocialWallPost);



// WEBPACK FOOTER //
// ./src/app/main/socialwall/socialwall-post.container.js